export default {
      id: "ic_lost-icon-usage",
      viewBox: "0 0 17 18",
      url: "/" + "images/icons.3.109.2.svg#ic_lost-icon-usage",
      toString: function () {
        return this.url;
      }
    }